var map = {
	"./arenera_balboa.png": 5631,
	"./bypass_cafe.png": 6583,
	"./cerro_punta.png": 7513,
	"./copanac_new.png": 1491,
	"./flex.png": 6170,
	"./furniture_city.png": 4143,
	"./grupo_sigma.png": 9944,
	"./hospital_nacional.png": 4241,
	"./itesa.png": 3207,
	"./kenneth_cole.png": 4204,
	"./nisato.png": 8947,
	"./plastifom.png": 2746,
	"./riba_smith.png": 6603,
	"./tecnilab.png": 3703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9959;